export default __webpack_public_path__ + "static/media/empty-consultations.b7e4d414.svg";